import {
  handleError,
  handleGetResponse,
  handlePostResponse,
} from '../utils/handleResponse'
import Token from '../utils/Token'

import * as types from '../constants/ActionTypes'
import { fetchServices } from './system'

export const fetchAppsPackages = () => (dispatch) => (
  fetch('/edge/api/acc/apps/packages/list', {
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.APPS_PACKAGES,
      packages: json,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const fetchAppsCapabilities = (appId, component) => (dispatch) => (
  fetch(`/edge/api/acc/apps/${appId}/capabilities?component=${component || ''}`, {
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.APPS_CAPABILITIES,
      capabilities: json,
    }))
    .catch((e) => {
      dispatch({
        type: types.APPS_CAPABILITIES_FAILED,
      })
      return handleError(e, dispatch)
    })
)

export const fetchAppsStructure = () => (dispatch) => (
  fetch('/edge/api/acc/apps/structure', {
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.APPS_STRUCTURE,
      structure: json,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const fetchAppsInfo = (appId, component) => (dispatch) => {
  const url = appId === 'all' ? '/edge/api/acc/apps/info'
    : `/edge/api/acc/apps/${appId}/info?component=${component || ''}`

  return fetch(url, {
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.APPS_INFO,
      info: json,
    }))
    .catch((e) => handleError(e, dispatch))
}

export const fetchAppsHealth = (appId, component) => (dispatch) => (
  fetch(`/edge/api/acc/apps/${appId}/health?component=${component || ''}`, {
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handleGetResponse(resp))
    .then((json) => dispatch({
      type: types.APPS_HEALTH,
      health: json,
    }))
    .catch((e) => handleError(e, dispatch))
)

export const toggleApp = (appId, component, running) => (dispatch) => {
  dispatch({
    type: types.SYSTEM_SERVICES_BUSY,
    busy: true,
  })

  dispatch({
    type: types.APPS_ACTION_ONGOING,
    appId,
    component,
    actionType: 'toggle',
  })

  return fetch(`/edge/api/acc/apps/${appId}/control/${running ? 'start' : 'stop'}?component=${component || ''}`, {
    method: 'POST',
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handlePostResponse(
      resp,
      dispatch,
      fetchServices,
      () => fetchAppsInfo(appId, component),
      () => fetchAppsHealth(appId, component),
    ))
    .then(() => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
      dispatch({
        type: types.APPS_ACTION_COMPLETE,
      })
    })
    .catch((e) => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
      dispatch({
        type: types.APPS_ACTION_COMPLETE,
      })
      return handleError(e, dispatch)
    })
}

export const restartApp = (appId, component) => (dispatch) => {
  dispatch({
    type: types.SYSTEM_SERVICES_BUSY,
    busy: true,
  })

  dispatch({
    type: types.APPS_ACTION_ONGOING,
    appId,
    component,
    actionType: 'restart',
  })

  return fetch(`/edge/api/acc/apps/${appId}/control/restart?component=${component || ''}`, {
    method: 'POST',
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handlePostResponse(
      resp,
      dispatch,
      fetchServices,
      () => fetchAppsInfo(appId, component),
      () => fetchAppsHealth(appId, component),
    ))
    .then(() => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
      dispatch({
        type: types.APPS_ACTION_COMPLETE,
      })
    })
    .catch((e) => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
      dispatch({
        type: types.APPS_ACTION_COMPLETE,
      })
      return handleError(e, dispatch)
    })
}

export const enabledAppVersion = (appId, version) => (dispatch) => {
  dispatch({
    type: types.SYSTEM_SERVICES_BUSY,
    busy: true,
  })

  return fetch(`/edge/api/acc/apps/${appId}/packages/enable/${version}`, {
    method: 'POST',
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handlePostResponse(
      resp,
      dispatch,
      fetchServices,
      fetchAppsPackages,
    ))
    .then(() => dispatch({
      type: types.SYSTEM_SERVICES_BUSY,
      busy: false,
    }))
    .catch((e) => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
      return handleError(e, dispatch)
    })
}

export const removeAppVersion = (appId, version) => (dispatch) => fetch(`/edge/api/acc/apps/${appId}/packages/remove/${version}`, {
  method: 'POST',
  headers: {
    'X-Jwt-Token': Token.get(),
  },
})
  .then((resp) => handlePostResponse(
    resp,
    dispatch,
    fetchServices,
    fetchAppsPackages,
  ))
  .catch((e) => handleError(e, dispatch))

export const clearAppStorage = (appId, component, option) => (dispatch) => {
  dispatch({
    type: types.SYSTEM_SERVICES_BUSY,
    busy: true,
  })

  dispatch({
    type: types.APPS_ACTION_ONGOING,
    appId,
    component,
    actionType: 'clear',
  })

  return fetch(`/edge/api/acc/apps/${appId}/storage/clear?&component=${component}&option=${option}`, {
    method: 'POST',
    headers: {
      'X-Jwt-Token': Token.get(),
    },
  })
    .then((resp) => handlePostResponse(
      resp,
      dispatch,
    ))
    .then(() => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
      dispatch({
        type: types.APPS_ACTION_COMPLETE,
      })
    })
    .catch((e) => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
      dispatch({
        type: types.APPS_ACTION_COMPLETE,
      })
      return handleError(e, dispatch)
    })
}

export const fetchAppsConfiguration = (appId) => (dispatch) => fetch(`/edge/api/acc/apps/${appId}/configuration`, {
  headers: {
    'X-Jwt-Token': Token.get(),
  },
})
  .then((resp) => handleGetResponse(resp))
  .then((json) => dispatch({
    type: types.APPS_CONFIGURATION,
    configuration: json,
  }))
  .catch((e) => handleError(e, dispatch))

export const setAppsConfiguration = (appId, configuration) => (dispatch) => fetch(`/edge/api/acc/apps/${appId}/configuration`, {
  method: 'POST',
  headers: {
    'X-Jwt-Token': Token.get(),
  },
  body: JSON.stringify(configuration),
})
  .then((resp) => handlePostResponse(
    resp,
    dispatch,
    () => fetchAppsConfiguration(appId),
  ))
  .catch((e) => handleError(e, dispatch))

export const fetchAppsSecrets = (appId) => (dispatch) => fetch(`/edge/api/acc/apps/${appId}/secrets`, {
  headers: {
    'X-Jwt-Token': Token.get(),
  },
})
  .then((resp) => handleGetResponse(resp))
  .then((json) => dispatch({
    type: types.APPS_SECRETS,
    secrets: { appId, secrets: json },
  }))
  .catch((e) => handleError(e, dispatch))

export const setAppsSecrets = (appId, secrets) => (dispatch) => fetch(`/edge/api/acc/apps/${appId}/secrets`, {
  method: 'POST',
  headers: {
    'X-Jwt-Token': Token.get(),
  },
  body: JSON.stringify(secrets),
})
  .then((resp) => handlePostResponse(
    resp,
    dispatch,
    () => fetchAppsSecrets(appId),
  ))
  .catch((e) => handleError(e, dispatch))

export const fetchAppsOptional = () => (dispatch) => fetch('/edge/api/acc/apps/optional', {
  headers: {
    'X-Jwt-Token': Token.get(),
  },
})
  .then((resp) => handleGetResponse(resp))
  .then((json) => dispatch({
    type: types.APPS_OPTIONAL,
    optional: json,
  }))
  .catch((e) => handleError(e, dispatch))

export const setAppsOptional = (optionals) => (dispatch) => {
  dispatch({
    type: types.SYSTEM_SERVICES_BUSY,
    busy: true,
  })

  return fetch('/edge/api/acc/apps/optional', {
    method: 'POST',
    headers: {
      'X-Jwt-Token': Token.get(),
    },
    body: JSON.stringify(optionals),
  })
    .then((resp) => handlePostResponse(
      resp,
      dispatch,
      fetchAppsOptional,
      fetchAppsStructure,
    ))
    .then(() => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
    })
    .catch((e) => {
      dispatch({
        type: types.SYSTEM_SERVICES_BUSY,
        busy: false,
      })
      return handleError(e, dispatch)
    })
}

export const fetchAppsSettings = (appId) => (dispatch) => fetch(`/edge/api/acc/apps/${appId}/settings`, {
  headers: {
    'X-Jwt-Token': Token.get(),
  },
})
  .then((resp) => handleGetResponse(resp))
  .then((json) => dispatch({
    type: types.APPS_SETTINGS,
    settings: { appId, settings: json },
  }))
  .catch((e) => handleError(e, dispatch))

export const setAppsSettings = (appId, settings) => (dispatch) => fetch(`/edge/api/acc/apps/${appId}/settings`, {
  method: 'POST',
  headers: {
    'X-Jwt-Token': Token.get(),
  },
  body: JSON.stringify(settings),
})
  .then((resp) => handlePostResponse(
    resp,
    dispatch,
    () => fetchAppsSettings(appId),
  ))
  .catch((e) => handleError(e, dispatch))
